<template>
    <div id="face-login">
        <div class="message">{{message}}</div>
        <div class="tip">{{$t('app.track.trackTip')}}</div>
        <div class="raster">
            <video id="face-login-video" autoplay loop muted></video>
            <canvas id='canvas-screenshot' style='display: none'></canvas>
        </div>
    </div>
</template>

<script>
    import '@/assets/lib/tracking';
    import 'tracking/build/data/face-min';
    import api from '@/api';
    import {Ticket} from "@/utils";
    const config = require("@/config");

    export default {
        props: {
            visible: Boolean
        },
        data() {
            return {
                message: this.$t('app.track.envMonitoring')
            }
        },
        created() {
        },
        mounted() {
            this.initTrack();
        },
        computed: {},
        methods: {
            initTrack() {
                this.$nextTick(() => {
                    const video = $("#face-login-video");

                    const canvas = document.getElementById('canvas-screenshot');
                    canvas.width = video.width();
                    canvas.height = video.height();
                    const context = canvas.getContext('2d');

                    this.videoTracker = new tracking.ObjectTracker(['face']);

                    this.videoTracker.setInitialScale(4);
                    this.videoTracker.setStepSize(2);
                    this.videoTracker.setEdgesDensity(0.1);


                    let isCountDown = false;

                    this.videoTrackerTask = tracking.track(`#${video.attr('id')}`, this.videoTracker, {camera: true});

                    this.videoTracker.on('track', (event) => {

                        if (!isCountDown) {
                            this.message = this.$t('app.track.faceMonitoring');
                        }
                        if (event.data.length === 1 && !isCountDown) {
                            this.message = this.$t('app.track.liveMonitoring');
                            isCountDown = true;
                            let count = 2;
                            this.fnCountDown = setInterval(() => {
//                                this.message = `${count + 1} 秒后拍照，请保持注视`;
                                this.message = this.$t('app.track.camera', [count + 1]);

                                if (count-- === 0) {
                                    video[0].pause();
                                    context.clearRect(0, 0, canvas.width, canvas.height);
                                    context.drawImage(video[0], 0, 0, video.width(), video.height());
                                    setTimeout(() => {
                                        clearInterval(this.fnCountDown);
                                        this.videoTrackerTask.stop();
                                        canvas.toBlob((blob) => {
                                            let formData = new FormData();
                                            formData.append('version', config.version);
                                            formData.append('upfile', blob, 'face_recognition');

                                            this.message = this.$t('app.track.checking');

                                            Ticket.remove()

                                            api.faceLogin(formData).then(res => {
                                                this.message = this.$t('app.track.loginSuccess');
                                                tracking.stream && tracking.stream.getTracks()[0].stop();

                                                // 登录成功
                                                this.$emit('faceLoginSuccess', res.package);
                                            }).catch(error => {

                                                this.message = error.data && error.data.message;
                                                tracking.stream && tracking.stream.getTracks()[0].stop();

                                                // 重新捕捉
                                                this.videoTrackerTask = tracking.track(`#${video.attr('id')}`, this.videoTracker, {camera: true});
                                                isCountDown = false;
                                            })
                                        })
                                    }, 0);
                                }
                            }, 1000)
                        }
                    });
                });
            }
        },
        watch: {
        },
        beforeDestroy() {
            clearInterval(this.fnCountDown);
            this.videoTrackerTask.stop();

            tracking.stream && tracking.stream.getTracks()[0].stop();
        },
        components: {}
    }
</script>

<style lang="scss">
    #face-login {

        .message {
            font-size: 16px;
            font-weight: 600;
            text-align: center;
        }

        .tip {
            margin-top: 10px;
            text-align: center;
        }

        .raster {
            margin-top: 12px;
            text-align: center;
        }
    }

    #face-login-video {
        margin: 0 auto;
        width: 320px;
        height: 240px;
    }
</style>
